import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

export default function CustomDialog({
  visible,
  onClose,
  children,
  header,
  handleSubmit,
  label,
  isClicked,
}) {
  return (
    <div className="z-5 flex justify-content-center">
      <Dialog
        header={header}
        visible={visible}
        style={{ width: "450px", overflowY: "scroll", overflow: "visible" }}
        onHide={onClose}
      >
        {children}
        {label ? (
          <div className="p-grid p-fluid">
            <div
              className="p-col-12 p-md-12 p-lg-12 p-xl-12"
              style={{ textAlign: "center" }}
            >
              <Button
                label={label}
                className="p-button-info"
                type="submit"
                onClick={handleSubmit}
                style={{ width: "50%", marginTop: "1.5em" }}
                disabled={isClicked}
              />
            </div>
          </div>
        ) : (
          <span></span>
        )}
      </Dialog>
    </div>
  );
}
